module.exports = __webpack_public_path__ + "img/play1_pc@2x.7e835cf1.png";